module.exports = __webpack_public_path__ + "img/icon_events_selected.ea99373e.svg";